import { render, staticRenderFns } from "./course_info.vue?vue&type=template&id=305f2f57&scoped=true&"
import script from "./course_info.vue?vue&type=script&lang=js&"
export * from "./course_info.vue?vue&type=script&lang=js&"
import style0 from "./course_info.vue?vue&type=style&index=0&id=305f2f57&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305f2f57",
  null
  
)

export default component.exports